module.exports = __webpack_public_path__ + "c5815d7360dfb763da422bcc81a2f16b.png";


//////////////////
// WEBPACK FOOTER
// ./work/animalz/img/right.png
// module id = 599
// module chunks = 0